<template>
  <div class="bzjCash">
    <div class="inqueryResult clearfix">
      <label class="title-line"></label>
      <span class="title">提现</span>
    </div>
    <el-card title="保证金提现" class="card-box">
      <el-form label-width="130px">
        <el-form-item label="可提现金额：">
          {{ (withdrawableAmount ? withdrawableAmount : 0) | thousandMark }}
          <span class="m-l-5">元</span>
        </el-form-item>
        <el-form-item label="提现至：">
          <el-select v-model="form.payerBankCardNum" placeholder="请选择" filterable @change="selectAccount">
            <el-option v-for="item in accountList" :key="item.id" :label="item.bankName +' '+ item.bankNo" :value="item.bankNo"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提现金额：">
          <el-input class="input" v-model="form.applyAmount" placeholder="请输入金额"></el-input>
          <span class='m-l-10'>元</span>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button @click="cancel">取消</el-button>
        <el-button class="sure" @click="sure">确认提现</el-button>
      </div>
    </el-card>

    <!-- 密码确认部分 -->
    <el-dialog :title="passwordHidden ? '请输入支付密码' : '提现申请'" :visible.sync="dialogVisible" width="450px" :before-close="close" :close-on-click-modal="false">
      <div class="link-top"></div>
      <el-form :inline="true" label-width="100px" class="center">
        <div v-if="passwordHidden">
          <el-row style="width: 400px;">
            <el-form-item label="" style="margin-left: 100px;">
              <el-input v-model='password' :type="isDesen ? 'password' : ''" placeholder='请输入6位支付密码' class="input" @input="checkPass(password, 'password')"></el-input>
              <div @click="select" class="tips">
                <img src="@/assets/password_hide.png" alt="" class="password" v-if="isDesen">
                <img src="@/assets/password_visual.png" alt="" class="password" v-if="!isDesen">
              </div>
            </el-form-item>
            <el-button class="sureTx" @click="sureTransfer" :loading="loading" style="width: 230px;">确认提现</el-button>
            <div class="btn">
              <span class="left" @click="cancel">取消提现</span>
              <span class="right" @click="forgetPass">忘记密码?</span>
            </div>
          </el-row>
        </div>
        <div style="text-align: center" v-else>
          <img :src="success" alt="">
          <div class='passSuss'>提现成功</div>
          <el-button class="sure-l" @click="cancel">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
    <forget-pass @closeMain="closeMain" v-if="isDisplay" editType='2'></forget-pass>
    <set-pass @closeMain="closeMain" v-if="isSetDisplay" :userId="userId"></set-pass>
  </div>
</template>

<script>
import Vue from 'vue'
import api from '@/api'
import CryptoJS from 'crypto-js'
import success from '@/assets/success.png'
import forgetPass from '@/components/forget-pass'
import setPass from '@/components/set-pass'
function Form () {
  return {
    payerBankCardNum: '', // 银行卡号
    applyAmount: '', // 提现金额
    receive: {}, // 收款账户信息
  }
}
export default {
  name: 'bzjCash', // 保证金提现
  components: {
    forgetPass,
    setPass
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      success: success,
      form: new Form(),
      accountList: [],
      withdrawableAmount: 0, // 可提现金额
      // 确认密码 忘记密码
      dialogVisible: false,
      passwordHidden: true,
      password: '',

      isDisplay: false,
      isSetDisplay: false,

      // 金额校验
      reg: /^\d+(\.\d{2})?$/,
      // 密码脱敏显示
      isDesen: true,
      // 用户id
      userId: Vue.ls.get('USER_INFO').userId,
      // 校验规则
      companyRules: [
        { name: 'payerBankCardNum', message: '请选择银行卡' },
        { name: 'applyAmount', message: '请输入提现金额' },
      ],
    }
  },
  mounted () {
    this.getAccountList()
    this.withdrawableAmount = this.row.userFundInfoDto.ava // 可提现金额
  },
  methods: {
    sure () {
      if (this.$utils.checkEmptyRules(this.form, this.companyRules)) {
        return false
      }
      if (!this.checkType(this.form.applyAmount)) { // 金额数字+数值校验
        return false
      }
      if (this.form.applyAmount > this.withdrawableAmount) {
        this.$message.error('提现金额不能大于可划转金额')
        return false
      }
      // 通过校验-输入密码
      this.dialogVisible = true
    },
    // 获取列表数据
    getAccountList (currentNo, pageSize) {
      let param = {
        pageNumber: 1,
        pageSize: 10
      }
      api.bankCard.getBankCardList(param).then((res) => {
        if (res.data) {
          this.accountList = res.data.rows
        }
      })
    },
    closeMain (e) {
      this.isDisplay = false
      this.isSetDisplay = false
    },
    // 密码验证
    async sureTransfer () {
      this.form.password = this.encryptByAes(this.password)
      if (this.userId) {
        const data = (await api.myAccount.checkHasPsw({ userId: this.userId })).data
        if (data === '1') {
          if (this.password === '') {
            this.$message.error('请输入支付密码')
            return false
          }
          this.loading = true
          const param = { ...this.form, ...this.form.receive }
          api.myAccount.bzjCash(param).then((res) => {
            this.$message.success('提现成功')
            this.passwordHidden = false
            this.loading = false
          }).catch(er => {
            this.loading = false
          })
        }
        if (data === '0') {
          this.$confirm('您还没有设置交易密码, 是否设置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.isSetDisplay = true
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消设置'
            })
          })
        }
      }
    },
    // 密码加密
    encryptByAes (psw) {
      let key = CryptoJS.enc.Utf8.parse('APP7apecSQznwPWD') // 秘钥
      let iv = CryptoJS.enc.Utf8.parse('307znw65426apecb') // 偏移量
      let srcs = CryptoJS.enc.Utf8.parse(psw)
      var encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.ciphertext.toString().toUpperCase()
    },
    // 密码脱敏显示
    select () {
      this.isDesen = !this.isDesen
    },
    // 忘记密码
    forgetPass () {
      this.isDisplay = true
    },
    // 金额校验
    checkType (v) {
      if (v < 0 || !v) {
        this.$message.error('提现金额不能小于0')
        this.form.applyAmount = ''
        return false
      }
      if (isNaN(v)) {
        this.$message.error('请输入数字')
        this.form.applyAmount = ''
        return false
      }
      return true
    },
    // 获取收款账户所有信息
    selectAccount () {
      const target = this.accountList.find(item => {
        return item.bankNo === this.form.payerBankCardNum
      })
      this.form.receive = target || {}
    },
    // 判断是否是数字
    checkPass (v, k) {
      if (!isNaN(v)) {
        this[k] = v
      } else {
        this[k] = ''
      }
    },
    // 取消提现
    cancel () {
      this.$emit('done', true)
    },
    // 关闭忘记密码弹窗
    close () {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.card-box {
  padding-top: 20px;
  height: 500px;
}
.inqueryResult{
  margin-top: 15px; // 与表格的margin保持一致
  height: 32px;
  line-height: 32px;
  .title-line {
    width:4px;
    height:14px;
    background-color:#f8bd47;
    display:inline-block
  }
  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #161616;
  }
}
.btn-box {
  padding-left: 130px;
  .sure {
    margin-top: 20px;
    background: #f8bd47;
    color: #fff;
    border: none;
  }
}
.input {
  width: 230px;
  height: 32px;
  line-height: 32px;
}

.password {
  width: 22px;
  height: 10px;
  float: left;
}
.tips {
  position: absolute;
  top: 16px;
  left: 198px;
  width: 25px;
  height: 25px;
}
.el-form-item {
  margin-bottom: 8px;
}
.inqueryResult{
  margin-top: 15px; // 与表格的margin保持一致
  height: 32px;
  line-height: 32px;
  .title-line {
    width:4px;
    height:14px;
    background-color:#f8bd47;
    display:inline-block
  }
  .title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    color: #161616;
  }
}
.gobal-form{
  .el-input, .el-input__inner{
    width:217px !important;
  }
  div.input-val{
    display:inline-block;
    width:217px;
  }
}
.input {
  width: 230px;
  height: 32px;
  line-height: 32px;
}
.amount {
  margin-left: 10px;
  color: #666666;
}
.card {
  width: 230px;
  height: 40px;
  background-color: #fafcfe;
  border: solid 1px #8cb5de;
  cursor:pointer;
  .radius {
    width: 12px;
    height:12px;
    border: 4px solid #409EFF;
    border-radius: 50%;
    margin: 12px 15px 0 15px;
    float: left;
  }
  .bank {
    width: 85px;
    height: 16px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333;
    margin-top: -2px;
    font-weight: 600;
    float: left;
  }
  .number {
    width: 64px;
    height: 16px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: 0px;
    color: #666666;
    margin-top: 10px;
    float: right;
    margin-right: 10px;
  }
}
.sure {
  margin: 20px 0 0 140px;
  // width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.sure-l {
  width: 260px;
  background: #f8bd47;
  color: #fff;
  margin-top: 40px;
}
.sureTx {
  margin: 20px 0 0 100px;
  width: 160px;
  background: #f8bd47;
  color: #fff;
  border: none;
}
.link-top {
  width: 100%;
  height: 1px;
  border-top: solid #f8bd47 1px;
  margin-bottom: 30px;
}
.btn {
  width: 55%;
  margin-left: 27%;
  margin-top: 30px;
  span {
    color: #5ca7ff;
    cursor:pointer;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
}
.passSuss {
  font-size: 14px;
  color: rgba(51, 51, 51, 0.94);
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  font-family: '微软雅黑';
  margin-top: 20px;
}
</style>
